<script lang="ts">
  // Компонент с описанием основных возможностей VPN
</script>

<section class="features" id="features">
  <div class="container">
    <h2 class="section-title">Могущество BlindEye VPN</h2>
    <p class="section-subtitle">Защитите свою анонимность с помощью нашего VPN</p>
    
    <div class="features-grid">
      <div class="feature-card">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h3 class="feature-title">Полная анонимность</h3>
        <p class="feature-description">
          Скройтесь от всевидящего ока в интернете. Наш VPN не хранит логи и обеспечивает полную анонимность.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <h3 class="feature-title">Высокая скорость</h3>
        <p class="feature-description">
          Молниеносное соединение для стриминга, игр и загрузки без задержек. Более 300 Мбит/сек.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 class="feature-title">35+ стран</h3>
        <p class="feature-description">
          Выбирайте из более чем 35 стран и 200 серверов по всему миру. Легко меняйте свое цифровое местоположение.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <h3 class="feature-title">До 10 устройств</h3>
        <p class="feature-description">
          Подключайте до 10 устройств с одной подпиской. Защитите все свои гаджеты одновременно.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z" />
          </svg>
        </div>
        <h3 class="feature-title">Разблокировка контента</h3>
        <p class="feature-description">
          Получите доступ к контенту, заблокированному по географическому признаку: Netflix, Disney+, Hulu и другие.
        </p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
        </div>
        <h3 class="feature-title">Защита Wi-Fi</h3>
        <p class="feature-description">
          Безопасное подключение в публичных Wi-Fi сетях. Защитите свои данные от киберугроз и хакеров.
        </p>
      </div>
    </div>
  </div>
</section>

<style>
  .features {
    padding: 6rem 0;
  }
  
  .section-title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 1rem;
  }
  
  .section-subtitle {
    font-size: 1.25rem;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 3rem;
    opacity: 0.8;
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
  }
  
  .feature-card {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 0.5rem;
    padding: 2rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 1px solid rgba(255, 69, 0, 0.2);
  }
  
  .feature-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(255, 69, 0, 0.1);
  }
  
  .feature-icon {
    margin-bottom: 1.5rem;
    width: 3rem;
    height: 3rem;
    color: var(--sauron-red);
  }
  
  .feature-title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 700;
  }
  
  .feature-description {
    opacity: 0.8;
    line-height: 1.6;
  }
  
  /* Адаптивная версия для мобильных */
  @media (max-width: 768px) {
    .features-grid {
      grid-template-columns: 1fr;
    }
    
    .section-title {
      font-size: 2rem;
    }
  }
  
  /* Стили для режима Шира */
  :global(body.shire-mode) .feature-card {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(34, 139, 34, 0.2);
  }
  
  :global(body.shire-mode) .feature-icon {
    color: var(--shire-green);
  }
</style> 